import { useMultiroomGetMultiroomQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useMultiroom = (pointId: string = '') => {
  const { data, loading } = useMultiroomGetMultiroomQuery({
    variables: {
      input: {
        pointId,
      },
    },
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
    skip: !pointId,
  });

  return {
    multiroom: data?.result,
    loading,
  };
};

export default useMultiroom;
